import registerWebComp from '@helsenorge/framework-utils/web-component/register';
import { startStyleObserverForComponent } from '@helsenorge/framework-utils/web-component/style-observer';

import Driftspanel from './components/driftspanel';
import Footer from './components/footer';
import HeaderWrapper from './components/header-wrapper';
import Infopanel from './components/infopanel';
import Uthopp from './components/uthopp';

async function enableMocking(): Promise<ServiceWorkerRegistration | void> {
  if (import.meta.env.MODE !== 'mocks') {
    return;
  }

  const { worker } = await import('./mocks/browser');

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

const TEMPLATE_ID = 'hn-webcomp-header-footer-template';

enableMocking().then(() => {
  registerWebComp(HeaderWrapper, { name: 'hn-webcomp-header', templateId: TEMPLATE_ID });
  registerWebComp(Footer, { name: 'hn-webcomp-footer', templateId: TEMPLATE_ID });
  registerWebComp(Uthopp, { name: 'hn-webcomp-uthopp', templateId: TEMPLATE_ID });
  registerWebComp(Driftspanel, { name: 'hn-webcomp-driftspanel', templateId: TEMPLATE_ID });
  registerWebComp(Infopanel, { name: 'hn-webcomp-infopanel', templateId: TEMPLATE_ID });

  startStyleObserverForComponent({
    templateId: TEMPLATE_ID,
    tagName: ['hn-webcomp-header', 'hn-webcomp-footer'],
    hrefFilter: href => !!href && href.includes('/header-footer/'),
  });
});
